module.exports = __webpack_public_path__ + "static/img/DSC_1563_02.2a2dd5aa.png";